import type { Variant } from "@/hooks/usePurchasedProductDetail";

export function findVariantBySelectedOptions(
  variants: Variant[],
  selectedOptions: Record<string, string>,
): Variant | null {
  return (
    variants.find((v) =>
      v.selected_options.every(
        (opt) => selectedOptions[opt.name] === opt.value,
      ),
    ) ?? null
  );
}

export function selectedOptionsFromVariant(
  variant: Variant,
): Record<string, string> {
  const record: Record<string, string> = {};
  for (const opt of variant.selected_options) {
    record[opt.name] = opt.value;
  }
  return record;
}
